<template>
  <div>

    <div style="display: flex;">

      <el-dialog title="" :visible.sync="anaInfosShow" :modal-append-to-body="false" width="60%">
        <anaInfos v-if="anaInfosShow" :anaType="anaType" :anaData="anaData"></anaInfos>
      </el-dialog>

      <div id="left-menu" class="content-son-box" style="width: 190px;margin-right: 10px;height: 100%;position: relative;top: 0px;">
        <div @click="back()"
          style="height: 30px;display: flex;align-items: center;font-weight: 600;cursor: pointer;">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path
              d="M8.45728 2.66904C8.60418 2.52192 8.71467 2.35638 8.78794 2.17243C8.86161 1.9887 8.89844 1.79936 8.89844 1.60507C8.89844 1.41056 8.86161 1.21875 8.78794 1.02961C8.71428 0.840481 8.6042 0.672482 8.45728 0.525345C8.16262 0.231105 7.81085 0.0839844 7.40073 0.0839844C6.99145 0.0839844 6.63885 0.231105 6.34502 0.525345L0.497413 6.42033C0.350088 6.54656 0.24498 6.70671 0.182055 6.90122C0.118738 7.09554 0.0926619 7.29791 0.103433 7.50792C0.113354 7.71815 0.160955 7.92549 0.244964 8.13034C0.328972 8.33561 0.444426 8.51151 0.591766 8.65841L6.34502 14.4588C6.63926 14.7638 6.99145 14.9161 7.40073 14.9161C7.81087 14.9161 8.16263 14.7638 8.45728 14.4588C8.60418 14.3119 8.71467 14.1464 8.78794 13.9626C8.86161 13.7789 8.89844 13.5893 8.89844 13.3952C8.89844 13.2007 8.86161 13.0087 8.78794 12.82C8.71467 12.6309 8.6042 12.4625 8.45728 12.3151L3.69684 7.49217L8.45728 2.66904Z"
              fill="#EA3928" />
          </svg>
          <span style="margin-left: 10px;">返回</span>
        </div>
        <div style="padding: 10px 0 10px 20px;font-size: 17px;">
          <!--            <div style="margin-bottom: 10px;">目录</div>-->
          <div v-for="(item, index) in listData" :key="index">
            <div style="margin-bottom: 10px;">
              <!-- <a style="text-decoration: none;color: #222;" :href="'#box-' + index">{{ item.riskBlock.blockName }}</a> -->
              <div style="cursor: pointer;color: #222;" @click="moveToId('#box-' + index)">{{ item.riskBlock.blockName }}</div>
            </div>
          </div>
        </div>
      </div>

      <div style="width: 1000px;">
        <div class="content-son-box" v-for="(item, index) in listData" :key="index" :id="'box-' + index">
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
            <span style="font-size: 17px;font-weight: 700;">{{ item.riskBlock.blockName }}</span>
          </div>
          <div style="margin-bottom: 10px;font-size: 15px;color: #6a6a6a;"
            v-if="item.riskBlock.generalDescription != null && item.riskBlock.generalDescription.length > 0">
            {{ item.riskBlock.generalDescription }}
          </div>
          <div v-if="item.riskBlock.depthRisk != null && item.riskBlock.depthRisk.length > 0">
            <div v-for="(item2, index2) in item.riskBlock.depthRisk" :key="index2" style="margin-bottom: 10px;">
              <div style="display: flex;align-items: center;">
                <i v-if="item2.riskLevel === '高风险'" class="el-icon-warning" style="color: #FF3344;margin-right: 5px;"></i>
                <i v-else-if="item2.riskLevel === '中风险'" class="el-icon-warning"
                  style="color: #FF9933;margin-right: 5px;"></i>
                <i v-else-if="item2.riskLevel === '低风险'" class="el-icon-warning"
                  style="color: #33AAFF;margin-right: 5px;"></i>
                <div style="font-size: 16px;color: #333;cursor: pointer;"
                  @click="viewAnaInfos(item2.predictionProcess)">{{ item2.subjectName }}</div>
                <div
                  style="margin-left: 10px;padding: 3px;background-color: #FFEBED;font-size: 14px;color: #FF3344;border-radius: 5px;">
                  深度</div>
              </div>
            </div>
          </div>
          <div v-if="item.riskBlock.detailsRisk != null && item.riskBlock.detailsRisk.length > 0">
            <div v-for="(item2, index2) in item.riskBlock.detailsRisk" :key="index2" style="margin-bottom: 10px;">
              <div style="display: flex;align-items: center;">
                <i v-if="item2.riskLevel === '高风险'" class="el-icon-warning" style="color: #FF3344;margin-right: 5px;"></i>
                <i v-else-if="item2.riskLevel === '中风险'" class="el-icon-warning"
                  style="color: #FF9933;margin-right: 5px;"></i>
                <i v-else-if="item2.riskLevel === '低风险'" class="el-icon-warning"
                  style="color: #33AAFF;margin-right: 5px;"></i>
                <div style="font-size: 16px;color: #333;cursor: pointer;"
                  @click="viewAnaInfos(item2.predictionProcess)">{{ item2.subjectName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>
    
<script>
import { linkName, sendRequestIndustry } from '../../../../static/js/util';
import anaInfos from '../business/anaInfos.vue';

export default {
  components: {
    anaInfos
  },
  data() {
    return {
      comCode: '',
      name: '',

      anaInfosShow: false,
      anaType: 0,
      anaData: null,

      listData: []
    };
  },
  mounted() {
    this.comCode = this.$route.query.comCode;
    this.name = this.$route.query.comName;

    window.parent.onscroll = () => {
      var scrollHeight = window.parent.scrollY;
      if (scrollHeight > 100) {
        $('#left-menu').css({ top: scrollHeight - 100 + 'px' });
      } else {
        $('#left-menu').css({ top: '0px' });
      }
    }

    this.getData();
  },
  methods: {
    back() {
      linkName(this, 'companyResearch');
    },
    moveToId(idStr) {
      document.querySelector(idStr).scrollIntoView({
        behavior: "smooth"
     });
    },
    getData() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });

      let url = '/company/riskPrediction/' + this.comCode;
      sendRequestIndustry(url, 'get', null, response => {
        loading.close();
        if (response.data.code === 0) {
          this.listData = response.data.data[0].analysisBlocks;

          //去掉空的项
          for (var i = 0; i < this.listData.length; i++) {
            if (this.listData[i] == null || this.listData[i].length < 1) {
              this.listData.splice(i, 1);
              i--;
            }
            // if(this.listData[i].showInfos[0].data.chartAnalysis[])
          }

        }
      }, error => {
        loading.close();
        console.log(error);
      })
    },
    viewAnaInfos(data) {
      // window.parent.researchVue.viewAnaInfos(data);
      this.anaType = 1;
      this.anaData = data;
      this.anaInfosShow = true;
    },
  }
};
</script>
    
<style scoped>
.content-son-box {
  margin-top: 30px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
</style>